export default "__VITE_ASSET__DK5RQ57m__"